// extracted by mini-css-extract-plugin
module.exports = {"reportDivider":"ReportTableListQuestionnaire_reportDivider__16Nzo"};